module.exports = __webpack_public_path__ + "src/img/texture/bg.jpg?44c8ce7a473418fa2d4e13786b77bc93";


//////////////////
// WEBPACK FOOTER
// ./src/img/texture/bg.jpg
// module id = 3
// module chunks = 0